import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const PATHWAY_PATH = 'pathway'

//#region Page
export function getPagePathways(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${PATHWAY_PATH}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region List
export function getListPathways(userId, dto, filterRequest) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${PATHWAY_PATH}/getList`, filterRequest, {
            params: {
                userId,
                dto,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Create Or Update
export function createOrUpdatePathway(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${PATHWAY_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Delete
export function deletePathway(userId, id) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${PATHWAY_PATH}/deleteById`, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
